import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Battery, Flame, Activity } from 'lucide-react';
export function ProofSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 20
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const milestones = [{
    time: 'Semana 1',
    desc: 'La neblina mental desaparece y la energía matutina regresa.',
    icon: Battery,
    color: 'text-[#00d4ff]',
    glow: 'box-glow-cyan'
  }, {
    time: 'Día 14',
    desc: 'La firmeza y el deseo sexual se vuelven imposibles de ignorar.',
    icon: Flame,
    color: 'text-amber-500',
    glow: 'shadow-[0_0_20px_rgba(245,158,11,0.15)]'
  }, {
    time: 'Día 21',
    desc: 'Habrás reprogramado tu sistema nervioso para operar desde el vigor, no desde el agotamiento.',
    icon: Activity,
    color: 'text-green-500',
    glow: 'shadow-[0_0_20px_rgba(34,197,94,0.15)]'
  }];
  return <section className="py-24 px-4 bg-[#0a0e1a] relative overflow-hidden" data-id="element-175">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#00d4ff] opacity-5 blur-[120px] pointer-events-none" data-id="element-176" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-177">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-178">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl font-black text-center text-white uppercase tracking-tight mb-16" data-id="element-179">
            Lo que cambia en{' '}
            <span className="text-[#00d4ff] text-glow-cyan" data-id="element-180">21 días</span>
          </motion.h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 relative" data-id="element-181">
            {/* Desktop connecting line */}
            <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-slate-800 -translate-y-1/2 z-0" data-id="element-182" />

            {milestones.map((milestone, idx) => {
            const Icon = milestone.icon;
            return <motion.div key={idx} variants={itemVariants} className={`bg-[#111827] rounded-2xl p-8 border border-white/10 relative z-10 ${milestone.glow}`} data-id="element-183">
                  <div className="flex flex-col items-center text-center" data-id="element-184">
                    <div className={`w-16 h-16 rounded-full bg-[#0a0e1a] border-2 border-current ${milestone.color} flex items-center justify-center mb-6`} data-id="element-185">
                      <Icon className="w-8 h-8" data-id="element-186" />
                    </div>
                    <h3 className="text-2xl font-bold text-white uppercase tracking-wide mb-4" data-id="element-187">
                      {milestone.time}
                    </h3>
                    <p className="text-slate-300 text-lg leading-relaxed" data-id="element-188">
                      {milestone.desc}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </motion.div>
      </div>
    </section>;
}